import React from 'react';
import { arrayOf, number, string, shape, func } from 'prop-types';

import SubMenuItem from './SubMenuItem';

const SubMenuList = ({ submenu, basePath, toggle, ...props }) => {
	if (!submenu) return null;
	return submenu.map((sublink) => (
		<SubMenuItem
			key={sublink.id}
			sublink={sublink}
			basePath={basePath}
			toggle={toggle}
			{...props}
		/>
	));
};

SubMenuList.propTypes = {
	submenu: arrayOf(
		shape({
			id: number.isRequired,
			name: string.isRequired,
			link: string.isRequired,
			model_id: string,
			model_type: string
		})
	).isRequired,
	basePath: string.isRequired,
	toggle: func.isRequired
};

export default SubMenuList;
